import { Buttons } from "components/Button"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { Heading } from "components/Text"
import heroImg from "public/maintenance-packages.webp"

import type { NextPage } from "next"

const Maintenance: NextPage = () => {
  return (
    <>
      <SEO
        titleTag="Maintenance - 3H CCTV &amp; Alarms"
        metaDescription="We offer alarm, access control &amp; CCTV maintenance packages for domestic &amp; commercial customers across Derbyshire, Nottinghamshire &amp; The Midlands."
        pageTitle="Maintenance"
      />
      <Layout>
        <Hero
          image={heroImg}
          imageClass="!object-center"
          imageAlt="CCTV &amp; Alarm Maintenance Derbyshire"
          heading="Maintenance"
        />

        <Section>
          <Container>
            <Heading alignment="center">Wireless alarms</Heading>
            <table className="text-center">
              <thead className="bg-black text-white text-lg">
                <tr>
                  <th>Package 1</th>
                  <th>Package 2</th>
                </tr>
                <tr>
                  <th>£95 + vat</th>
                  <th>£135 + vat</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Pyronix Cloud subscription - needed for mobile notifications
                    and remote viewing (£36 annually to purchase separately)
                  </td>
                  <td>
                    Pyronix Cloud subscription - needed for mobile notifications
                    and remote viewing (£36 annually to purchase separately)
                  </td>
                </tr>
                <tr>
                  <td>
                    Change of batteries for any sensors/key fobs attached to the
                    system on every second annual service, or before if required
                    (up to 8 devices)
                  </td>
                  <td>
                    Change of batteries for any sensors/key fobs attached to the
                    system on every second annual service, or before if required
                    (up to 16 devices)
                  </td>
                </tr>
                <tr>
                  <td>
                    Change of batteries for a Siren attached to the system on
                    every second annual service (or before if required)
                  </td>
                  <td>
                    Change of batteries for up to 2 Sirens attached to the
                    system on every second annual service (or before if
                    required)
                  </td>
                </tr>
                <tr>
                  <td>
                    Change of back-up batteries for the control unit on every
                    third annual service (or before if required)
                  </td>
                  <td>
                    Change of back-up batteries for the control unit on every
                    third annual service (or before if required)
                  </td>
                </tr>
                <tr>
                  <td>
                    Full test of the system including a walk test, functionality
                    of the system and signal strength tests of all zones
                  </td>
                  <td>
                    Full test of the system including a walk test, functionality
                    of the system and signal strength tests of all zones
                  </td>
                </tr>
                <tr>
                  <td>
                    Code reset and settings/firmware updates as needed/requested
                  </td>
                  <td>
                    Code reset and settings/firmware updates as needed/requested
                  </td>
                </tr>
                <tr>
                  <td>Full support, and diagnostics of any problem</td>
                  <td>Full support, and diagnostics of any problem</td>
                </tr>
                <tr>
                  <td>
                    Free lifetime repair/replacement of any part of the alarm
                    system for as long as the servicing is still ongoing
                  </td>
                  <td>
                    Free lifetime repair/replacement of any part of the alarm
                    system for as long as the servicing is still ongoing
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    Up to 2 annual callout&rsquo;s to make edits to the system
                    including changing/adding zones, and adding/deleting users
                  </td>
                </tr>
              </tbody>
            </table>
          </Container>
        </Section>

        <Section>
          <Container>
            <Heading alignment="center">CCTV</Heading>
            <table className="text-center">
              <thead className="bg-black text-white text-lg">
                <tr>
                  <th>POA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Firmware upgrade if a newer firmware is available</td>
                </tr>
                <tr>
                  <td>Test the functionality of the system</td>
                </tr>
                <tr>
                  <td>Cleaning of all cameras attached to the system</td>
                </tr>
                <tr>
                  <td>Repositioning of cameras where required</td>
                </tr>
                <tr>
                  <td>Hard drive health check</td>
                </tr>
                <tr>
                  <td>
                    Cleaning and internal dust removal of DVR unit, hard drive
                    and fan
                  </td>
                </tr>
              </tbody>
            </table>
          </Container>
        </Section>

        <Section variant="gray-200" className="text-center">
          <Container>
            <Heading alignment="center">
              Arrange a maintenance package with us today
            </Heading>
            <p>
              Our maintenance packages are available for new systems as well as
              taking over maintenance of existing systems.
            </p>
            <Buttons
              className="justify-center"
              buttons={[{ kind: "phone" }, { kind: "contactFormPopUp" }]}
            />
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export default Maintenance
